import { createApi } from '@reduxjs/toolkit/query/react'

import { v2RootQuery } from './v2BaseQuery'

export const rootApi = createApi({
  reducerPath: 'root',
  baseQuery: v2RootQuery,
  endpoints: () => ({
    // Define your endpoints here
  }),
})
